import z from 'zod';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import { varOrConstSchema } from '../var.zod';

const thresholdSchema = z.object({
    id: z.string(),
    value: z.number(),
    color: z.string(),
});

export const gaugeCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('gauge'),
    attrs: cellCfgAttrsBaseSchema.extend({
        sourceVar: z.string(),
        baseColor: z.string(),
        boundingMode: z.enum([ 'percent', 'range' ]),
        minValue: z.number(),
        maxValue: z.number(),
        variant: z.enum([ 'timer', 'speedometer' ]),
        colorMode: z.enum([ 'thresholds', 'var' ]),
        thresholds: z.array(thresholdSchema).max(10).optional(),
        dialColorVar: z.string().optional(),
        label: varOrConstSchema(z.string()).optional(),
        labelOverlay: z.boolean().optional(),
        roundedBars: z.boolean().optional(),
    }),
});
